import { Component, EventEmitter, Output } from '@angular/core';
import { FlightService } from 'src/app/services/flight.service';
import { DatePipe, Location } from '@angular/common';
import {CarrierCodeService} from '../../services/carrier-code.service';
import {TripService} from 'src/app/services/trip.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DataService } from 'src/app/services/data.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { Router ,ActivatedRoute, NavigationEnd} from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import {CartService} from '../../services/cart.service';

export enum Status {
  Initiated = 'I',
  Booked = 'B',
  Cancel = 'C',
  Failed = 'Failed',
}
@Component({
  selector: 'app-trip-summary',
  templateUrl: './trip-summary.component.html',
  styleUrls: ['./trip-summary.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TripSummaryComponent {
  getStatusDescription(status: string): string {
    if (status === Status.Initiated) {
      return 'Failed';
    } else if (status === Status.Booked) {
      return 'Booked';
    } else if (status === Status.Cancel) {
      return 'CANCELLED';
    }
     else if (status === 'N') {
      return 'Failed';
    } 
    else {
      return 'Failed';
    }
  }
carrierCode:any=[]
userUuid:any
flightList:any=[]
hotelList:any=[]
// 'bookedBy'
columnsToDisplayWithExpand = ['expand','firstDeparture','summary','failedAttempts','bookingStatus','paymentStatus'];
columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus','paymentStatus'];
expandedHElement!: any | null;
expandedElement!: any | null;
// ,'bookingStatus','paymentStatus'
// 'bookedBy','corporate_Agent'
tripUid:any
constructor(private CartService:CartService,private UserService:UserService,private router:Router,private route:ActivatedRoute,private DialogService:DialogService,private ToastmsgService:ToastmsgService, private data:DataService,private userInfoService:UserInfoService,private TripService:TripService,private FlightService:FlightService,private CarrierCodeService:CarrierCodeService){
  this.getFlightList()
  this.userUuid=this.userInfoService.getUserUuid()
  this.carrierCode=this.CarrierCodeService.carrierCode()
  this.route.paramMap.subscribe(params => {
    let id= params.get('token');
    if(id){
     this.tripUid=id
   //  this.paymentOrderData(id)
    }
   });
   this.ENABLE_TRIP_MGMT()

   

}


airPortFilter(item:any){
  
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.name
return item}else{
  return item
}
}

getFlightList(){
   
  this.FlightService
  .getFlightList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       this.flightList=data
   
      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}

converter(item:any){
  const totalMinutes = item ;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  item=`${hours}h ${remainingMinutes}m`
  return item
}
fligthNameFilter(item:any){
if(item){
let flightName:any=[]
flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
if(flightName.length===0){
 return item

}else{
 flightName =flightName[0].flightName
 return flightName
}}else{
return item
}
}
cityFilter(item:any){
  

  if(item && this.flightList){
   

    item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

  item=item[0]?.city

return item}else{
  return item
}
}

timeFormate(date:any){
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'hh:mma');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

 return date

}
// convertToISOStringFormat(dateString:any) {
//   // Remove the ' 00:00' part and then add 'Z' at the end
//   const isoDateString = dateString?.replace('00.000 00:00', '00.000Z');
//   return isoDateString;
// }
flightlogoFilter(item:any){
  
  if(item){
     let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0]?.logo
   return flightName
 }
  }else{return item}
 }
 dateFormate(date:any){

  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}

refresh(){
  if(this.tripUid){
    this.getByTripId()
   }else{
    this.getActiveTripList()

   }
}
tripResponse:any={}


getByTripId(){
  this.TripService
  .getTripByTripId(this.tripUid)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.tripResponse={
          tripName:data?.tripName,
          cabRequired:data?.tripDetails?.cabHire,
          cabLocation:data?.tripDetails?.cabLocation,
          cabAddress:data?.tripDetails?.cabAddress,
          cabPickUpTime:data?.tripDetails?.cabPickUpTime,
            hotelRequired:data?.tripDetails?.hotelRequired,
          tripUid:data?.tripUid,
          status:data?.status,
          approvalLevel1Email:data?.approvalLevel1Email,
          statusDesc:data?.statusDesc,
          tripDetail:data?.tripDetails

        }
        if(!this.tripEnable){

if(this.tripResponse.status==='Z'||this.tripResponse.status==='B'||this.tripResponse.status==='F'){
       this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','approvalStatus','bookingStatus','paymentStatus'];
       this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','approvalStatus','bookingStatus','paymentStatus'];
}else{
       this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','approvalStatus'];
       this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','approvalStatus'];
       }}else{
        if(this.tripResponse.status==='A'){

        this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','bookingStatus','approvalStatus','paymentStatus'];
       this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus','paymentStatus'];
      }else if(this.tripResponse.status==='I'||this.tripResponse.status==='D'){
        // this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','failedAttempts','bookingStatus','paymentStatus','approvalStatus'];
        // this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus','paymentStatus'];
        this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','bookingStatus','approvalStatus'];
        this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus'];
      }
      else{
        this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','bookingStatus'];
        this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus'];

       }
       }
       this.getcartTripList()
       this.getcartHTripList()
       } else {

       } 
    },error : (err) => {

      console.error("Error in fetching result");
    }
  })}









  getActiveTripList(){
    this.TripService
    .getActiveTrip( this.userUuid)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          this.tripResponse={
            cabRequired:data?.tripDetails?.cabHire,
            hotelRequired:data?.tripDetails?.hotelRequired,
            cabLocation:data?.tripDetails?.cabLocation,
            cabAddress:data?.tripDetails?.cabAddress,
            cabPickUpTime:data?.tripDetails?.cabPickUpTime,
            tripName:data?.tripName,
            tripUid:data?.tripUid,
            status:data?.status,
            approvalLevel1Email:data?.approvalLevel1Email,
            statusDesc:data?.statusDesc,
            tripDetail:data?.tripDetails

          }
          if(!this.tripEnable){
            console.log('no')

if(this.tripResponse.status==='Z'||this.tripResponse.status==='B'||this.tripResponse.status==='F'){
         this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','approvalStatus','bookingStatus','paymentStatus'];
         this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','approvalStatus','bookingStatus','paymentStatus'];
}else{
  
         this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','approvalStatus'];
         this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','approvalStatus'];
         }
        }else{
          if(this.tripResponse.status==='A'){

          this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','bookingStatus','approvalStatus','paymentStatus'];
          this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus','paymentStatus'];
          }else if(this.tripResponse.status==='I'||this.tripResponse.status==='D'){
            // this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','failedAttempts','bookingStatus','paymentStatus','approvalStatus'];
            // this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus','paymentStatus'];

            this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','bookingStatus','approvalStatus'];
            this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus'];
            
          }
          else{
            this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','bookingStatus'];
            this.columnsToDisplayHWithExpand = ['expand','firstDeparture','summary','bookingStatus'];
          }
        }
         this.getcartTripList()
         this.getcartHTripList()
         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching result");
      }
    })}
    airList:any[]=[]
     airTotal:any=0
     bookStatus:boolean=false
     filterSearch:any=[]
     summary:any
     showCancel:boolean=true
    getcartTripList(){
      this.totalAirLowerFare=0
        this.TripService
        .getItemTrip(this.tripResponse?.tripUid,'AIR')
        .subscribe({
          next : (res:any) => {
            if(res) {
              const data = res
              this.airList=data
              // this.airList=this.airList.sort((item:any)=>item.status==='B')
              this.airList = this.airList.sort((a: any, b: any) => {
                if (a.status === "B" && b.status !== "B") return -1;
                if (a.status !== "B" && b.status === "B") return 1;
                return 0;
              });
              // console.log(this.airList.length)
            //  this.flightIti
            let totalAmount:any=0
            // console.log(this.airList.Each((item:any)=>item.status==='B'))
            let filterSearch:any=[]
           let filter:any=[]
           this.airList.forEach((ite:any)=>{
            if(ite.status!='B'){
              
              // this.columnsToDisplayWithExpand = ['expand','firstDeparture','summary','failedAttempts','bookingStatus'];

          filterSearch.push(...this.tripResponse.tripDetail.airSearchRequestBaseDetails.filter((search:any)=>search.fromAirport===ite.fromAirport&&search.toAirport===ite.toAirport))
            }
            if(ite.status==='B'){
              filter.push(...this.tripResponse.tripDetail.airSearchRequestBaseDetails.filter((search:any)=>search.fromAirport===ite.fromAirport&&search.toAirport===ite.toAirport))

            }
            // if(ite.status==='B'){
            //   filter.push(...this.tripResponse.tripDetail.airSearchRequestBaseDetails.filter((search:any)=>search.fromAirport===ite.fromSource&&search.toAirport===ite.toDestination))

            // }
          })
          this.bookStatus = this.airList.every((d:any) => filter.some((l:any) => d.toAirport === l.toAirport&&d.fromAirport === l.fromAirport));
          this.showCancel=this.airList.every((d:any) => filter.some((l:any) => l.status != 'B'))
         // this.showCancel=this.airList.every((d:any) =>  d.status === 'B')

// console.log(this.showCancel)
          this.filterSearch=filterSearch

            for(let list of this.airList){
             


//               if(list.status!='B'){

// this.bookStatus=true
//               }
              totalAmount+=list?.itineraryCost||0
              // this.getLOWERTripDATA(list?.requestUuid)
// for(let airItineraries of list.airItineraries){
    // totalAmount+=airItineraries?.repriceData?.fare?.baseFare?(airItineraries?.repriceData?.fare?.baseFare):0+airItineraries?.repriceData?.fare?.finalTax?(airItineraries?.repriceData?.fare?.finalTax):0+airItineraries?.commissionData?.finalAmount?(airItineraries?.commissionData?.finalAmount):0
//} 
}
            this.airTotal=totalAmount
             let summary:any=[]
        for(let list of this.airList){
          
          this.CartService.getOrder(list.cartId)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data:any
     data=res
     list.airItineraries=[]
     list.airItineraries=data?.airItineraries.filter((item:any)=>item.fromSource===list.fromAirport&&item.toDestination===list.toAirport)||[]
    
     }}})
          // if(list!='B'){
          //   // let listSummary:any=list.fromAirport+'-'+list.toAirport+'_'
          //   // summary.push(listSummary)
          //   // list.summary.push
          // }
         
        }
        // this.summary=summary.join('\n')
        // this.airList=[...this.airList.filter((item:any)=>item.status==='B'),...this.airList.filter((item:any)=>item.status!='B')[0]]
             } else {
    
             } 
          },error : (err) => {
    
            console.error("Error in fetching result");
          }
        })}
        
        hotelTotal:any=0
        getcartHTripList(){
          this.totalHotelLowerFare=0
          this.TripService
          .getCartTrip(this.tripResponse?.tripUid,'HOTEL')
          .subscribe({
            next : (res:any) => {
              if(res) {
                const data = res
                this.hotelList=data
                
              //  this.flightIti
              let totalAmount:any=0
              for(let list of this.hotelList){
                if(list.status!='OK'){
                  this.bookStatus=true
                                }
                totalAmount+=list.hotelItineraries[0].hotelDetails?.hotel?.mmtRooms[0]?.ratePlans[0]?.totalAmount||0
  // for(let airItineraries of list.hotelItineraries){
   }
              this.hotelTotal=totalAmount
               
               } else {
      
               } 
            },error : (err) => {
      
              console.error("Error in fetching result");
            }
          })}


totalAirLowerFare:any=0

          getLOWERTripDATA(id:any){
            let requestId
            this.TripService
            .getLowerTrip(requestId)
            .subscribe({
              next : (res:any) => {
                if(res) {
                  const data = res
                //  this.flightIti
                let totalAmount:any=0
                  this.totalAirLowerFare+=totalAmount||0
                  
    // for(let airItineraries of list.hotelItineraries){
     
                 
                 } else {
        
                 } 
              },error : (err) => {
        
                console.error("Error in fetching result");
              }
            })}
            totalHotelLowerFare:any=0

            getLOWERHTripDATA(id:any){
              let requestId
              this.TripService
              .getLowerTrip(requestId)
              .subscribe({
                next : (res:any) => {
                  if(res) {
                    const data = res
                  //  this.flightIti
                  let totalAmount:any=0
                    this.totalHotelLowerFare+=totalAmount||0
      // for(let airItineraries of list.hotelItineraries){
       
                   
                   } else {
          
                   } 
                },error : (err) => {
          
                  console.error("Error in fetching result");
                }
              })}
        formatDate(val: Date) {
            let convertedValue:any = ""
            if(val){
            let datepipe = new DatePipe("en");
            //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
            convertedValue =  datepipe.transform(val, "dd-MM-yyyy HH:mm:ss");
            // convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        
            }
            return convertedValue;
          }
        totalService(bookingTime: any, gents: any) {
            let bookingTs: any = new Date(bookingTime);
            let creationTs: any = new Date(gents);
            let duration: any = (bookingTs - creationTs) / 1000; // Convert milliseconds to seconds
            // console.log(duration);
        
            return duration.toFixed(0)+' Seconds'
          }
        supplierService(bookingTime: any, bookingRequestTs: any) {
            // console.log(bookingTime)
            // console.log(bookingRequestTs)
        
            let bookingTs: any = new Date(bookingTime);
            let BookingRequestTs: any = new Date(bookingRequestTs);
            let duration: any = (bookingTs - BookingRequestTs) / 1000; // Convert milliseconds to seconds
            // console.log(duration);
        
            return duration.toFixed(0)+' Seconds'
          }
          ServiceUser(bookingRequestTs: any, gents: any) {
            
        
            let BookingRequestTs: any = new Date(bookingRequestTs);
            let creationTs: any = new Date(gents);
            let duration: any = (BookingRequestTs - creationTs) / 1000; // Convert milliseconds to seconds
            // console.log(duration);
        
            return duration.toFixed(0)+' Seconds'
          }
          @Output() myOutput:EventEmitter<string>= new EventEmitter();  
          outputMessage:string="close";
          formatSummaryDate(val: any) {
            const timestamp = val;
            const date = new Date(timestamp);
          
        
            const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short' };
            const formattedDate = date.toLocaleDateString('en-GB', options).replace(',', '');
            
        
            // console.log(formattedDate)
           return formattedDate.replace(' ','-'); // Output: "17-Jun"
            
          }
          generateUUIDv4(): string {
            let date:any=new Date().getDate();
            let time:any=new Date().getTime();
            let uuidDate:any=date+time;
            // console.log(date+"t"+time)
            return uuidDate+'-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
              const r = Math.random() * 16 | 0;
              const v = c === 'x' ? r : (r & 0x3 | 0x8);
              return v.toString(16);
            });
          }
          onClickAir(){
            console.log(this.filterSearch)
            // window.location.href="/app/flight"
            this.data.deliverMsg('default message')

console.log(this.filterSearch)

if(this.filterSearch.length===1){

  let data:any={}
  data={

    "airSearchRequestBaseDetails": this.filterSearch,
    "journeyType":'oneWay',
    "paxCount": this.tripResponse.tripDetail.paxCount,
    "adultCount": this.tripResponse.tripDetail.adultCount,
    "childCount": this.tripResponse.tripDetail.childCount,
    "infantCount": this.tripResponse.tripDetail.infantCount,
}
let uuid:any=this.generateUUIDv4()
data.requestId=uuid
data.uuid=uuid
data.cabHire=this.tripResponse.tripDetail.cabHire
data.hotelRequired=this.tripResponse.tripDetail.hotelRequired

data.requestFor=this.tripResponse.tripDetail.requestFor
data.onBehalf=this.tripResponse.tripDetail.onBehalf 
data.travelType='oneWay'
data.pointerEvents=true
this.data.deliverMsg(data)

this.myOutput.emit(this.outputMessage);

  this.router.navigate(["/app/flightlist"]);

}else if(this.filterSearch.length===2){

  let data:any={}
  data={

    "airSearchRequestBaseDetails": this.filterSearch,
    "journeyType":'return',
    "paxCount": this.tripResponse.tripDetail.paxCount,
    "adultCount": this.tripResponse.tripDetail.adultCount,
    "childCount": this.tripResponse.tripDetail.childCount,
    "infantCount": this.tripResponse.tripDetail.infantCount,
}
let uuid:any=this.generateUUIDv4()
data.requestId=uuid
data.uuid=uuid
data.cabHire=this.tripResponse.tripDetail.cabHire
data.hotelRequired=this.tripResponse.tripDetail.hotelRequired

data.requestFor=this.tripResponse.tripDetail.requestFor
data.onBehalf=this.tripResponse.tripDetail.onBehalf 
data.travelType='return'
data.pointerEvents=true
this.data.deliverMsg(data)

this.myOutput.emit(this.outputMessage);
  if(this.tripResponse.tripDetail.travelType==='AI'){
    this.router.navigate(["/app/flight-intl-list"]);
  
  }else{
    this.router.navigate(["/app/flightList"]);
  
  }
} else if(this.filterSearch.length>2){
  let data:any={}
  data={

    "airSearchRequestBaseDetails": this.filterSearch,
    "journeyType":'multiCity',
    "paxCount": this.tripResponse.tripDetail.paxCount,
    "adultCount": this.tripResponse.tripDetail.adultCount,
    "childCount": this.tripResponse.tripDetail.childCount,
    "infantCount": this.tripResponse.tripDetail.infantCount,
}
let uuid:any=this.generateUUIDv4()
data.requestId=uuid
data.uuid=uuid
data.cabHire=this.tripResponse.tripDetail.cabHire
data.hotelRequired=this.tripResponse.tripDetail.hotelRequired

data.requestFor=this.tripResponse.tripDetail.requestFor
data.onBehalf=this.tripResponse.tripDetail.onBehalf 
data.travelType='multiCity'
data.pointerEvents=true
this.data.deliverMsg(data)

this.myOutput.emit(this.outputMessage);
  if(this.tripResponse.tripDetail.travelType==='AI'){
    this.router.navigate(["/app/flight-intl-list"]);

  }else{
    this.router.navigate(["/app/flightList"]);

  }




}

            if(this.tripResponse.tripDetail.tripType==='return'){}
            if(this.tripResponse.tripDetail.tripType==='multiCity'){}
            if(this.tripResponse.tripDetail.tripType==='oneWay'){}

          }
          onClickHotel(){
            window.location.href="/app/hotel"
            this.data.deliverMsg('default message')

          }
          calculateStayNights(firstDate: string, lastDate: string): number {
            const first = new Date(firstDate);
            const last = new Date(lastDate);
          
            // Calculate the difference in time
            const diffTime = last.getTime() - first.getTime();
          
            // Convert time difference to days
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let totalDays:any=0
          if(diffDays>1){
            totalDays= diffDays+" Night(s)"
          }else{
            totalDays= diffDays+" Night"
          
          }
            return totalDays;
          }

          starArray(item:any){
            // console.log(item)
          
            let star=[]
            if(item){
              // console.log(item)
            for(let i=0;i<item;i++){
            star.push(i+1)
            }}
          
            // console.log(star)
            return star
          }

          approvalDescription:any=''

          tripApproval(){
            let request:any={
              tripUid:this.tripResponse?.tripUid
              // ,tripState:''
              ,notes:this.approvalDescription
              // ,approvalReferenceId:''

            }

              
    
    
            
            this.TripService
            .tripApproval(request)
            .subscribe({
              next : (res:any) => {
                this.ToastmsgService.setMsg({msg : "Approval Sent successfully!",msgTitle : "Success", msgType : "I"});

                if(this.tripUid){
    this.getByTripId()
   }else{
    this.getActiveTripList()

   }
                let msg:any=''
                if(this.tripResponse.approvalLevel1Email){
                  msg='Approval Sent to '+this.tripResponse?.approvalLevel1Email
                }
                this.DialogService.open({msg :msg ,title : "Information",buttonType : "Ok"})
           
                this.DialogService.onResponse((response :  string) => {
                 
                  if(response=="OK") {
                  }})
                
              },error : (err) => {
                this.ToastmsgService.setMsg({msg : "Failed !",msgTitle : "Warning", msgType : "W"});

              }
            })  
          }
showPending:boolean=false
            tripBooked(){
              this.showPending=true
              this.ShowPopup=true
              this.TripService
              .tripBook(this.tripResponse?.tripUid)
              .subscribe({
                next : (res:any) => {
                  this.showPending=false

                  // this.ToastmsgService.setMsg({msg : " successfully!",msgTitle : "Success", msgType : "I"});
                  if(this.tripUid){
                    this.getByTripId()
                   }else{
                    this.getActiveTripList()
                
                   }
                   
                  
                },error : (err) => {
                  this.showPending=false

                  this.ToastmsgService.setMsg({msg : "Failed !",msgTitle : "Warning", msgType : "W"});
  
                }
              })}
            ShowPopup:boolean=false

            onModifyHClick(data:any){
              // let url= "/app/modify-cart?id="+this.SettingsService.transform(item)
              // window.open(url);
              // this.dataService.deliverMsg(data)
              let url="/app/modifyCart?id="+data.uuid
              
              window.open(url)
              // this.showStatus=false
              // this.modifyCart=true
              // this.screenChange=true
          
            }

            onModifyClick(data:any){
              // let url= "/app/modify-cart?id="+this.SettingsService.transform(item)
              // window.open(url);
              let url="/app/modify-cart?id="+data.cartId
              window.open(url)
              // this.showStatus=false
              // this.modifyCart=true
              // this.screenChange=true
          
            }

            successPopup:boolean=false
            action:any
            showScreen:boolean=false
            Approve(){
              this.showScreen=true

              this.currentRoute='approval-trip'

            }
            onApprove() {
              // this.successPopup=true
          this.action='A'

              this.createTrip('A')
              // alert(`Approved with comment: ${this.comment}`);
              // Add logic for approve action
            }
          //   APPROVED.   ====>. A
          // DECLINED.   ======> D
          comment:any=''
            createTrip(status:any) {
          
              let request:any={
                "approvalNotes":this.comment,
                "tripUid":this.tripUid,
                "status":status,
              }
              
               this.TripService
               .approveTripRequest(request)
               .subscribe({
                 next : (res:any) => {
                  this.successPopup=true
                  this.showScreen=false

                this.ToastmsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
                   if(res) {
                  let data=res
                  if(this.tripUid){
                    this.getByTripId()
                   }else{
                    this.getActiveTripList()
                
                   }
                   } else {
                   
                   } 
                 },error : (err) => {
           
                   this.ToastmsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});
             
                 }
               }
             )
             
               // Logic for trip creation goes here.
             }
             currentRoute:any
             Reject(){
              this.showScreen=true
              this.currentRoute='reject-trip'

             }
             cancel(){
              this.showScreen=false
              this.successPopup=false

             }
            onReject() {
              
              this.action='D'
              // this.successPopup=true
              this.createTrip('D')
          
              // alert(`Rejected with comment: ${this.comment}`);
              // Add logic for reject action
            }
           disableCancel:boolean=false
            onClickSingleCancel(item:any){
              this.DialogService.open({msg :'Are you sure you want to cancel your '+item.fromAirport+'-'+item.toAirport+' trip?' ,title : "Information",buttonType : "YesNo"})
           
              this.DialogService.onResponse((response :  string) => {
               
                if(response=="Yes") {
                  this.disableCancel=true

                  let items:any={...item}
                  delete items.airItineraries
                  let data={
                  tripAirItemList:[items]
                  }
                  this.TripService
                  .approveTripCancilRequest(data)
                  .subscribe({
                    next : (res:any) => {
                      this.disableCancel=false

                     // this.successPopup=true
                     // this.showScreen=false
   
                   this.ToastmsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
                      if(res) {
                     let data=res
                     if(this.tripUid){
                       this.getByTripId()
                      }else{
                       this.getActiveTripList()
                   
                      }

                      } else {
                      
                      } 
                    },error : (err) => {
                      this.disableCancel=false

                      this.ToastmsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});
                
                    }
                  })

                }})
            }

            onClickCancel(){
              
              let request:any={
                "approvalNotes":'',
                "tripUid":this.tripResponse.tripUid,
                "status":'D'
              }
              this.DialogService.open({msg :'Are you sure you want to cancel the Complete Trip?' ,title : "Information",buttonType : "YesNo"})
           
                this.DialogService.onResponse((response :  string) => {
                 
                  if(response=="Yes") {
                    this.disableCancel=true

               this.TripService
               .approveTripRequest(request)
               .subscribe({
                 next : (res:any) => {
                  this.disableCancel=false

                  // this.successPopup=true
                  // this.showScreen=false

                this.ToastmsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
                   if(res) {
                  let data=res
                  if(this.tripUid){
                    this.getByTripId()
                   }else{
                    this.getActiveTripList()
                
                   }
                   } else {
                   
                   } 
                 },error : (err) => {
                  this.disableCancel=false
                   this.ToastmsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});
             
                 }
               }
             )
            }})
            }
          
            tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        
        if(res.rule==='2'){
          this.tripEnable=true
                    }else{
          this.tripEnable=false

        }

       }
 
      }else{

      }
      if(this.tripUid){
        this.getByTripId()
       }else{
        this.getActiveTripList()
    
       }
    },error : (err) => {
      if(this.tripUid){
        this.getByTripId()
       }else{
        this.getActiveTripList()
    
       }
        console.error("Error in fetching data");
      }
    }
  )
  
}

generatePDF(item:any,invoiceLabel:any){
  // console.log(item)
  this.FlightService
  .downloadCartPdf(item.cartId,invoiceLabel)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
      //  console.log(data).replace(',','_')
var fileName = "Ticket_"+item?.trip?.tripUid + ".pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
      } else {    
      } 
    },error : (err) => {


    }
  }
)

}
}
